"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStringResponses = exports.parseResponses = void 0;
var content_1 = require("./content");
var util_1 = require("../util");
var alignWithSelectionOrBoolean_1 = require("../util/alignWithSelectionOrBoolean");
function parseResponses(content, condition, targetQuestion, prefillAlternates) {
    if (prefillAlternates === void 0) { prefillAlternates = []; }
    var questionResponses = parseStringResponses(content, condition, targetQuestion, prefillAlternates);
    if (util_1.isSingleResponseQuestion(targetQuestion)) {
        questionResponses = questionResponses.slice(questionResponses.length - 1);
    }
    questionResponses = questionResponses
        .map(function (r) { return alignWithSelectionOrBoolean_1.alignWithSelectionOrBoolean(r, targetQuestion); })
        .filter(function (r) { return r.answer; });
    return questionResponses;
}
exports.parseResponses = parseResponses;
function parseStringResponses(content, condition, targetQuestion, prefillAlternates) {
    if (prefillAlternates === void 0) { prefillAlternates = []; }
    var responses = content_1.getStringValues(content, condition.prefillAnswerField, prefillAlternates).map(function (answer) { return ({
        answer: answer || "",
        questionId: targetQuestion.id,
        questionRootId: targetQuestion.rootId,
        timeAnswered: new Date().toISOString(),
    }); });
    if (condition.prefillAssociatedIdField) {
        var ids = content_1.getNumberValues(content, condition.prefillAssociatedIdField, prefillAlternates);
        if (ids.length === responses.length) {
            for (var i = 0; i < responses.length; i++) {
                responses[i].associatedId = ids[i];
            }
        }
        else {
        }
    }
    if (condition.prefillAssociatedLocation) {
        var locations = content_1.getGeoPointValues(content, condition.prefillAssociatedLocation, prefillAlternates);
        if (locations.length === responses.length) {
            for (var i = 0; i < responses.length; i++) {
                responses[i].associatedLocation = locations[i];
            }
        }
        else {
        }
    }
    var parents = content_1.getParentContent(content, condition.prefillAssociatedIdField || condition.prefillAnswerField, prefillAlternates);
    if (parents.length === responses.length) {
        for (var i = 0; i < responses.length; i++) {
            responses[i].parentContent = parents[i];
        }
    }
    return responses.filter(function (r) { return r.answer; });
}
exports.parseStringResponses = parseStringResponses;
//# sourceMappingURL=contentParser.js.map